export * from './recommendations/recommendations.component';
export * from './recommendations-item/recommendations-item.component';
